export const isSomeDataItemUsedInGfunction = dataItems =>
  dataItems.some(({ gfunctions }) => gfunctions.length);

export const getChildDatasetsDataItems = childDatasets =>
  childDatasets?.reduce((acc, dataset) => acc.concat(dataset.dataItems), []) || [];

export const areChildDatasetsUsedInForms = childDatasets =>
  childDatasets?.some(({ forms }) => Boolean(forms));
